import request from '@/api/request.js'

/**
 * 音效资源问题反馈管理接口。
 *
 * 反馈处理与通用“用户建议”分开维护，因为资源反馈需要关联具体音效、
 * 版权档案和展示策略，避免把两类不同业务强行塞进同一套字段。
 */
const apis = {
  /**
   * 获取反馈原因、状态和处理建议选项。
   *
   * @returns {Promise}
   */
  options() {
    return request({ url: '/admin_soundcomplaint/options', method: 'GET' })
  },

  /**
   * 分页读取资源反馈。
   *
   * @param {Object} params 查询条件和分页参数
   * @returns {Promise}
   */
  lists(params = {}) {
    return request({ url: '/admin_soundcomplaint/lists', method: 'GET', params })
  },

  /**
   * 保存工作人员的处理状态、建议动作和备注。
   *
   * @param {Object} data 反馈处理表单
   * @returns {Promise}
   */
  update(data) {
    return request({ url: '/admin_soundcomplaint/update', method: 'POST', data })
  },

  /**
   * 删除已经由工作人员核实为误报的反馈。
   *
   * @param {Object} data 包含反馈 id
   * @returns {Promise}
   */
  remove(data) {
    return request({ url: '/admin_soundcomplaint/remove', method: 'POST', data })
  }
}

export default apis
